import React, { useState } from 'react';
import OnsiteSignatureDialog from './OnsiteSignatureDialog';

// Page 1 signature section (IGFEMS-585): a preview box that opens the signing popup.
// Locked = signature already saved → shown read-only, no re-sign (IGFEMS-634 rule).
const OnsiteSignatureField = ({ value, locked, signerName, onChange }) => {
  const [open, setOpen] = useState(false);

  if (locked) return (
    <div className="onsite-sig-field onsite-sig-field--locked">
      {value && <img src={value} alt="Saved signature" className="onsite-sig-field__img" />}
      <span className="onsite-review__lock"><i className="fa-solid fa-lock" aria-hidden="true" /> Locked</span>
    </div>
  );

  return (
    <>
      {value ? (
        <div className="onsite-sig-field">
          <img src={value} alt="Your signature" className="onsite-sig-field__img" />
          <button type="button" className="onsite-review__change onsite-sig-field__again" onClick={() => setOpen(true)}>
            <i className="fa-solid fa-pen-nib" aria-hidden="true" /> Sign again
          </button>
        </div>
      ) : (
        <button type="button" className="onsite-sig-field onsite-sig-field--empty" onClick={() => setOpen(true)}>
          <i className="fa-solid fa-pen-nib" aria-hidden="true" /> Tap to sign
        </button>
      )}
      <OnsiteSignatureDialog show={open} onHide={() => setOpen(false)} onSave={onChange} signerName={signerName} />
    </>
  );
};

export default OnsiteSignatureField;
